import { render, staticRenderFns } from "./StudentsBySchool.vue?vue&type=template&id=33f6d7fe&scoped=true&"
import script from "./StudentsBySchool.vue?vue&type=script&lang=js&"
export * from "./StudentsBySchool.vue?vue&type=script&lang=js&"
import style0 from "./StudentsBySchool.vue?vue&type=style&index=0&id=33f6d7fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f6d7fe",
  null
  
)

export default component.exports